/* eslint-disable react-hooks/exhaustive-deps */
import{FC, useEffect, useMemo, useState} from 'react'
import NPTab5Form from '../../../modules/apps/project/components/ProjectNewEdit/NPTab5Form'
import { parseProposalServicesDataToTable } from '../helpers/proposalServicesParser'
import { useAuth } from '../../../modules/auth'
import {  useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { useSelector } from 'react-redux'
import { getPointVigilance,  getProposal, getProposalMaterialList, getProposalSettings, putProposalSubmit } from '../../../modules/apps/project/core/_requests'
import { toast } from 'react-toastify'
//import { Tables } from '../../../modules/widgets/components/Tables'
//import Tab5Table from '../../../modules/apps/project/components/ProjectNewEdit/Tab5Table'

const NPProposal: FC = () => {

  const {setAuthMessage, logout} = useAuth()
  const {pGuid} = useParams()
  const intl = useIntl()
  const {mode,} = useThemeMode()
  const projectData = useSelector((state: any) => state?.projectData)
  const [loading, setLoading] = useState<boolean>(true)
  const [materielOptions, setMaterielOptions] = useState<Array<any>>([])
  //const [locationDate, setLocationDate] = useState<string>('')
  const [selectedMateriel, setSelectedMateriel] = useState<any>(null)
  const [proposal, setProposal] = useState<any>(null)
  //const [showbq, setShowbq] = useState<boolean>(false)
  // const [showCancel, setShowCancel] = useState<boolean>(false)
  //const [w2go, setW2go] = useState<'tab1' | 'tab2' | 'tab4' | 'tab3'>('tab1')
  //const [isThereModif, setIsThereModif] = useState<boolean>(false)
  //const [ws, setWs] = useState<any>(null)
  const [project, ] = useState<any>(null)
  const [settings, setSettings] = useState<any>(null)
  const [tableRows, setTableRows] = useState<Array<any>>([])
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [vigilent, setVigilent] = useState<any>(null)
  const [comments, setComments] = useState<string>('')
  const [updating, setUpdateing] = useState<boolean>(false)

  //const navigate = useNavigate()

  // const loadWorkSite = async () => {
  //   const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
  //   const wsObjRes = await getWorkSite(
  //     {Guid: ProjectGuid},
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     },
  //     ({Message, MessageType, Toast, ToastType}) => {
  //       if (Message && MessageType === 'Success') {
  //         //
  //       } else if (Message && MessageType === 'Error') {
  //         //
  //       } else if (Toast && ToastType === 'Success') {
  //         toast(Toast, {type: 'success'})
  //       } else if (Toast && ToastType === 'Error') {
  //         toast(Toast, {type: 'error'})
  //       }
  //     }
  //   )
  //   if (wsObjRes?.data?.data) {
  //     setWs(wsObjRes?.data?.data)
  //   }
  // }

  // const loadProject = async () => {
  //   const projectRes = await getProjectByGuid(
  //     {Guid: pGuid || projectData?.tab1?.data?.Guid || ''},
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     },
  //     ({Message, MessageType, Toast, ToastType}) => {
  //       if (Message && MessageType === 'Success') {
  //         //
  //       } else if (Message && MessageType === 'Error') {
  //         //
  //       } else if (Toast && ToastType === 'Success') {
  //         toast(Toast, {type: 'success'})
  //       } else if (Toast && ToastType === 'Error') {
  //         toast(Toast, {type: 'error'})
  //       }
  //     }
  //   )
  //   if (projectRes && projectRes?.data?.data) {
  //     setProject(projectRes?.data?.data)
  //   }
  // }

  const loadListMateriel = async () => {
    const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
    const listMatRes = await getProposalMaterialList(ProjectGuid, (message: string) => {
      setAuthMessage(message)
      logout()
    })
    if (listMatRes && listMatRes.data.data) {
      const opts = listMatRes.data.data?.map((op: any, ik: number) => {
        return {
          ...op,
          value: op?.Guid,
          label: op?.Name,
        }
      })

      if (opts && opts?.length > 0) {
        await setMaterielOptions(opts)

        if(selectedMateriel) {
         const uptadeSelectedMaterial =  opts.find((opt:any) => opt?.Guid === selectedMateriel?.Guid)
          setSelectedMateriel(uptadeSelectedMaterial ?? opts[0])
        }
        else {
          setSelectedMateriel(opts[0])
        }
      }
    }
    setLoading(false)
  }

  const loadVigilancePoint = async () => {
    const vigilance = await getPointVigilance()
    if (vigilance?.data?.data) {
      setVigilent(vigilance?.data?.data)
    }
  }

  const loadProposalSettings = async () => {
    const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
    const settRes = await getProposalSettings(
      {
        ProjectGuid: ProjectGuid || '',
        MaterialGuid: selectedMateriel?.Guid || '',
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      }
    )
    if (settRes?.data?.data) {
      setSettings(settRes?.data?.data)
      console.log('settRes : ', settRes)
    }
    // setLoading(false)
  }

  const loadProposal = async () => {
    setProposal(null)
    setLoading(true)
    const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
    const proposalData = await getProposal(
      {
        ProjectGuid: ProjectGuid,
        MaterialGuid: selectedMateriel?.Guid || '',
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      }
    )
    if (proposalData && proposalData?.data?.data) {
      setProposal(proposalData?.data?.data)
      // const dataStructed: Array<any> = parseProposalServicesDataToTable(proposalData?.data?.data?.Services || [])
      // let tableData: Array<any> = [];
      // tableData = proposalData?.data?.data?.Services
      //   ? [tHeader, ...dataStructed]
      //   : []
      setTableRows([...proposalData?.data?.data?.Services])
    }
    setLoading(false)
  }


  const updateProposal = async () => {
    setUpdateing(true)
    console.log('projectData?.tab1?.data : ', projectData?.tab1?.data || project)
    const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
    const mandates: any[] = []
    settings?.Mandatory?.forEach((mand: any) => {
      if (mand?.Selected === true) {
        mandates.push(mand?.Guid)
      }
      // return mand?.Guid
    })
    const otionals: any[] = []
    settings?.Optional?.forEach((mand: any) => {
      if (mand?.Selected === true) {
        otionals.push(mand?.Guid)
      }
      // return mand?.Guid
    })
    const data = {
      ProjectGuid: ProjectGuid,
      MaterialGuid: settings?.MaterialGuid,
      Mandatory: mandates,
      Optional: otionals,
      Comment: comments,
    }
    const res = await putProposalSubmit(
      data,
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          toast(Message, {type: 'success'})
        } else if (Message && MessageType === 'Error' && Message !== 'Accès expiré') {
          toast(Message, {type: 'error'})
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {

        }
      }
    )
    setUpdateing(false)

    if (res.data?.Status?.Success) {
      setSubmitting(false)
      await loadProposalSettings()
      await loadListMateriel()//loadProposal()
    }

    else {
      toast('Erreur fatale retournée par le serveur', {type: 'error'})
    }

  }

  // const handleMaterielChange = (selcted: any) => {
  //   setSelectedMateriel(selcted)
  // }

  // const handleBackPress = () => {
  //   setW2go('tab4')
  //   if (isThereModif) {
  //     setShowbq(true)
  //   } else {
  //     navigate('/new-project/tab4' + (pGuid ? '/' + pGuid : ''), {replace: true})
  //   }
  // }

  useEffect(() => {
    const loadData = async () => {
      if (selectedMateriel) {
        await loadProposalSettings()
        await loadProposal()
      } else {
        await loadListMateriel()
        await loadVigilancePoint()
      }
    }
    loadData()
  }, [selectedMateriel])

  const tHeader: any = {
    columns: [
      {
        colIndex: 0,
        dataKey: 'VisuCode',
        rowGuid: 'Code_Visu',
        rowIndex: 0,
        type: 'text',
        value: 'VisuCode',
      },
      {
        colIndex: 1,
        dataKey: 'ServiceTitle',
        rowGuid: 'ServiceTitle',
        rowIndex: 0,
        type: 'text',
        value: 'ServiceTitle',
      },
      {
        colIndex: 2,
        dataKey: 'Quantity',
        rowGuid: 'Quantity',
        rowIndex: 0,
        type: 'text',
        value: 'Quantity',
      },
      {
        colIndex: 3,
        dataKey: 'UnitPrice',
        rowGuid: 'UnitPrice',
        rowIndex: 0,
        type: 'text',
        value: 'UnitPrice',
      },
      {
        colIndex: 3,
        dataKey: 'SubTotal',
        rowGuid: 'SubTotal',
        rowIndex: 0,
        type: 'text',
        value: 'SubTotal',
      },
    ],
    rowGuid: 'HeaderTC',
    rowIndex: 0,
    rowType: 'header',
  }

  const tableData = useMemo(() => {
    return tableRows
    ? [tHeader, ...parseProposalServicesDataToTable(tableRows, {Sort: 'VisuCode', Order: 'asc'})]
    : []
  },[tableRows])


  useEffect(() => {
    if (selectedMateriel) {
      loadProposal()
    }
  }, [mode])

  return (
    <div className='container-fluid'>
      <NPTab5Form
        setSubmitting={setSubmitting}
        submitting={submitting}
        loading={loading}
        materielOptions={materielOptions}
        proposal={proposal}
        settings={settings}
        tableData={tableData}
        updating={updating}
        vigilent={vigilent}
        selectedMateriel={selectedMateriel}
        updateProposal={updateProposal}
        onCommentChange={(text) => {
          setComments(text)
        }}
        onSettingsChange={(setting) => {
          setSettings(setting)
        }}
        onSelectMaterial={(mat: any) => {
          setSelectedMateriel(mat)
        }}

      >
        {/*<Tab5Table tableData={tableData} activeSort={null} onSort={(sort)=> {}} />*/}
        <div  className="table-responsive w-sm-80 w-100  overflow-auto">
            <table className="table table-row-bordered table-row-gray-300">
              <thead>
              <tr className="fw-bold fs-6 text-gray-800">
                <th className="text-gray-400 fw-bolder">
                 <div className="text-nowrap" >
                  <span> {intl.formatMessage({id:'VisuCode'})}</span>
                 </div>
                </th>
                <th className="text-gray-400 fw-bolder">
                  <div className="text-nowrap" >
                    <span> {intl.formatMessage({id:'ServiceTitle'})}</span>
                  </div>
                </th>
                <th className="text-gray-400 fw-bolder text-center">
                  <div className="text-nowrap" >
                    <span> {intl.formatMessage({id:'Quantity'})}</span>
                  </div>
                </th>
                <th className="text-gray-400 fw-bolder text-end">
                  <div className="text-nowrap" >
                    <span> {intl.formatMessage({id:'UnitPrice'})}</span>
                  </div>
                </th>
                <th className="text-gray-400 fw-bolder text-end">
                  <div className="text-nowrap" >
                    <span> {intl.formatMessage({id:'SubTotal'})}</span>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              {
                tableRows.map((data,index) =>{
                  return (
                      <tr key={index} style={{backgroundColor: mode === "dark" ? "#000000" : !(index % 2) ? "#F5F8FA":'white'}}>
                        <td>{data?.VisuCode || ''}</td>
                        <td  style={{color: '#57586C'}}>{data?.ServiceTitle || ''}</td>
                        <td className='text-center'>{data?.Quantity || ''}</td>
                        <td className='text-end'>{data?.UnitPrice}</td>
                        <td className='text-end'>{data?.SubTotal}</td>
                      </tr>
                  )
                })
              }
              </tbody>
            </table>
        </div>
      </NPTab5Form>
    </div>
  )
}

export default NPProposal
